export const ITEM_ACCESS = {
  MANAGE: 'manage',
  EDIT: 'edit',
  READ: 'read'
}
